import { useState } from 'react';

export const reducerStartEvent = 'onreducerstart';
export const reducerEndEvent = 'onreducerend';

const useAsyncReducer = (
	reducer: (arg0: any, arg1: any) => any,
	initState: any
) => {
	const [state, setState] = useState(initState);

	const dispatchState = async (action: any) => {
		window.dispatchEvent(new Event(reducerStartEvent));
		const reducedState = await reducer(state, action);
		return (
			setState(reducedState),
			window.dispatchEvent(new Event(reducerEndEvent))
		);
	};

	return [state, dispatchState];
};

export default useAsyncReducer;
